// components/TransitionLink.jsx
import React from 'react';
import { useTransition } from '../context/TransitionContext';

const TransitionLink = ({ to, children, className, onClick, ...props }) => {
    const { startTransition } = useTransition();

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (onClick) {
            onClick(e);
        }

        startTransition(to);
    };

    return (
        <a
            href={to}
            onClick={handleClick}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleClick(e);
                }
            }}
            className={`${className} cursor-pointer`}
            {...props}
        >
            {children}
        </a>
    );
};

export default TransitionLink;